<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} khách du lịch
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form ref="myForm" label-position="top" @submit.native.prevent
                :model="mData.tableRules.dataSearch.value" :rules="mData.tableRules.dataSearch.valid">
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Tên" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value['ho_ten.ten']" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Giới tính" prop="">
                      <el-select v-model="mData.tableRules.dataSearch.value.gioi_tinh" :placeholder="aLang.c_select"
                        clearable filterable>
                        <el-option v-for="item in mData.dataDefault.listGioiTinh" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Số thẻ" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value.so_the" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Số điện thoại" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value['dien_thoai']" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Email" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value.email" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Địa chỉ" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value['dia_chi.dia_chi']" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button type="info" native-type="submit" v-ladda plain
                    @click="fn_tableSearch()">{{ aLang.c_search }}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col :class="'col-md-8'">
          </b-col>
          <b-col :class="'col-md-4'">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{ aLang.c_showHideSearch }}</el-button>
              <el-button @click="fn_handle('create')" v-if="mData.ifHaveCreate" type="info"
                plain>{{ aLang.c_create }}</el-button>
            </div>
          </b-col>
        </b-row>
        <el-table :data="mData.tableRules.data" border @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange" max-height="440" style="width: 100%"
          :default-sort="{ prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1] }">
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column label="STT" width="50">
            <template slot-scope="scope">
              <div class="text-center">
                {{ mData.tableRules.offset + scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ho_ten.ho_ten" label="Tên" :sortable="mData.tableRules.allowSorting">
            <template slot-scope="scope">
              <el-link class="cell-child" target="_blank" @click="fn_handle('detail', scope.$index, scope.row)"
                :underline="false">{{ scope.row.ho_ten.ho_ten }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="gioi_tinh" label="Giới tính" :sortable="mData.tableRules.allowSorting" width="120px">
          </el-table-column>
          <el-table-column prop="dien_thoai" label="Điện thoại" :sortable="mData.tableRules.allowSorting">
          </el-table-column>
          <el-table-column prop="so_the" label="Số thẻ" :sortable="mData.tableRules.allowSorting">
          </el-table-column>
          <el-table-column prop="email" label="Email" :sortable="mData.tableRules.allowSorting">
          </el-table-column>
          <el-table-column prop="ngay_sinh.ngay_sinh" label="Ngày sinh" :sortable="mData.tableRules.allowSorting">
            <template slot-scope="scope">
              <div class="text-center">
                {{(scope.row.ngay_sinh || {}).ngay_sinh || ''}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="dia_chi.dia_chi" label="Địa chỉ" :sortable="mData.tableRules.allowSorting">
            <template slot-scope="scope">
              <div class="text-center">
                {{(scope.row.dia_chi && scope.row.dia_chi.dia_chi ? scope.row.dia_chi.dia_chi : '')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="70px">
            <template slot-scope="scope">
              <el-button size="mini" @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail">
                <i class="fa fa-eye"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">{{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination @size-change="fn_tableSizeChange" @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick" @next-click="fn_tableNextClick" :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit" :current-page="mData.tableRules.page" background
              layout="total, sizes, prev, pager, next, jumper" :total="mData.tableRules.total"
              :pager-count="5"></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import KhachDuLichApi from '../../../moduleApi/KhachDuLichApi';
import MethodService from '../../../service/MethodService';
import KhachDuLichModel from './KhachDuLichModel';
import DataService from '@/service/DataService';
export default {
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        moduleName: "KhachDuLich", //requied
        tableRules: MethodService.copyObject(KhachDuLichModel.tableRules),
        dataForm: MethodService.copyObject(KhachDuLichModel.dataForm),
        dataDefault: {
          listGioiTinh: [
            {
              value: "1",
              label: 'Nữ'
            },
            {
              value: "2",
              label: 'Nam'
            },
            {
              value: "3",
              label: 'Chưa có thông tin'
            },
            {
              value: "4",
              label: 'Khác'
            },
          ]
        }
      }
    }
  },
  created() {
    this.fn_hashUrl();
    this.getKhachDuLichList();
  },
  methods: {
    async getKhachDuLichList() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters
            }
          })
          .catch(() => { });
      }

      let res = await KhachDuLichApi.list(dataFilter);
      let resData = await this.fn_changeData(res.result);

      //end get name
      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.getKhachDuLichList();
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      $.each(resData, (index, item) => {
        if (item.gioi_tinh != undefined) {
          let gt = DataService.gioiTinh.find(element => {
            return element.id == item.gioi_tinh;
          });
          if (gt) {
            item.gioi_tinh = gt.text;
          }
        }
        // if (item.ngay_sinh != undefined) {
        //   item.ngay_sinh.ngay_sinh = new Date(
        //     item.ngay_sinh.nam,
        //     item.ngay_sinh.thang - 1,
        //     item.ngay_sinh.ngay
        //   ).toUTCString();
        // }
        if (!item.ngay_sinh || (item.ngay_sinh && (!item.ngay_sinh.ngay || !item.ngay_sinh.thang || !item.ngay_sinh.nam))) {
          item['ngay_sinh'] = { ngay_sinh: null };
        } else {
          item.ngay_sinh.ngay_sinh =
            ("0" + item.ngay_sinh.ngay).slice(-2) +
            "/" +
            ("0" + item.ngay_sinh.thang).slice(-2) +
            "/" +
            item.ngay_sinh.nam;
        }
      });
      return resData;
    },
    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.getKhachDuLichList();
    },
    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getKhachDuLichList();
    },
    // search
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value['dien_thoai']) {
        this.mData.tableRules.dataSearch.value['dien_thoai'] = this.mData.tableRules.dataSearch.value['dien_thoai'].trim();
      }
      this.$refs["myForm"].validate(async valid => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          let m = this.mData.tableRules.filters.match(/dien_thoai(%3D|=)([^&|]*)/g);
          if (
            this.mData.tableRules.dataSearch.value['dien_thoai'] &&
            this.mData.tableRules.dataSearch.value['dien_thoai'].substr(0, 1) == "0" &&
            this.mData.tableRules.dataSearch.value['dien_thoai'].length == 10
          ) {
            if (m) {
              this.mData.tableRules.filters = this.mData.tableRules.filters.replace(m[0], m[0] + "|dien_thoai=" + this.mData.tableRules.dataSearch.value['dien_thoai'].replace(/^\d/, '84'));
            }
          } else if (
            this.mData.tableRules.dataSearch.value['dien_thoai'] &&
            this.mData.tableRules.dataSearch.value['dien_thoai'].substr(0, 2) == "84" &&
            this.mData.tableRules.dataSearch.value['dien_thoai'].length == 11
          ) {
            if (m) {
              this.mData.tableRules.filters = this.mData.tableRules.filters.replace(m[0], m[0] + "|dien_thoai=" + this.mData.tableRules.dataSearch.value['dien_thoai'].replace(/^\d{2}/, '0'));
            }
          }
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.getKhachDuLichList();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_handle(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        let m = this.mData.tableRules.filters.match(/\|?dien_thoai=([^&|]*)/g);
        if (m) {
          this.mData.tableRules.filters = this.mData.tableRules.filters.replace(m[1], '');
        }
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
        this.fn_search();
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
    fn_search() {
      this.mData.tableRules.filters = MethodService.filterTable(JSON.stringify(this.mData.tableRules.dataSearch));
      let m = this.mData.tableRules.filters.match(/dien_thoai(%3D|=)([^&|]*)/g);
      if (
        this.mData.tableRules.dataSearch.value['dien_thoai'] &&
        this.mData.tableRules.dataSearch.value['dien_thoai'].substr(0, 1) == "0" &&
        this.mData.tableRules.dataSearch.value['dien_thoai'].length == 10
      ) {
        if (m) {
          this.mData.tableRules.filters = this.mData.tableRules.filters.replace(m[0], m[0] + "|dien_thoai=" + this.mData.tableRules.dataSearch.value['dien_thoai'].replace(/^\d/, '84'));
        }
      } else if (
        this.mData.tableRules.dataSearch.value['dien_thoai'] &&
        this.mData.tableRules.dataSearch.value['dien_thoai'].substr(0, 2) == "84" &&
        this.mData.tableRules.dataSearch.value['dien_thoai'].length == 11
      ) {
        if (m) {
          this.mData.tableRules.filters = this.mData.tableRules.filters.replace(m[0], m[0] + "|dien_thoai=" + this.mData.tableRules.dataSearch.value['dien_thoai'].replace(/^\d{2}/, '0'));
        }
      }
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.sort = "";
      this.getKhachDuLichList();
    }
  }
}
</script>
